import React, { useEffect, useState } from "react";
import TransactionModal from "./TransactionModal";
import CloseIcon from "../../../assets/svgs/closeIcon.svg";
import SuccessIcon from "../../../assets/svgs/success.svg";
import ViewIcon from "../../../assets/svgs/viewOnExplorer.svg";
// import CloseIcon from "@material-ui/icons/Close";
import { CircularProgress } from "@material-ui/core";
import useStyles from "./transactionModalStyles";
import BigNumber from "bignumber.js";
import millify from "millify";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { bscScanExplorerURL, chains, etherScanExplorerURL, supportedChains } from "../../../contract/constant";

function TransactionSuccessfull({
  transactionCompleted,
  setTransationCompleted,
  setValue,
  chainId,
  value,
  transactionHash,
setTransactionHash,
height,
type,
sendToClaim,
claimTokensModal,
claimItem
}) {
  const classes = useStyles();
  return (
    <div>
      <TransactionModal open={transactionCompleted} height={height} claimTokensModal={claimTokensModal}>
        <div>
          <div>
            <img
              src={CloseIcon}
              // style={{
              //   display: "flex",
              //   marginLeft: "auto",
              //   fontWeight: "500",
              //   // transform: "scale(1.4)",
              //   cursor: "pointer",
              //   marginTop: "10px",
              // }}
              className={classes.closeIcon}
              onClick={async () => {
                await setTransationCompleted(false);
                await setTransactionHash("");
                (type=="deposite")&&sendToClaim(1);
                await setValue("");
              }}
            />
          </div>
          <div style={{ color: "#282828", textAlign: "center" }}>
            <div style={{filter:"drop-shadow( 3px 3px 20px rgba(255, 223, 0, 0.7))" }}>
              <img src={SuccessIcon}
                style={{
                  color: "#FFDF00",
                  fontWeight: "900",
                  fontSize: "80px",
                }}
              />
            </div>
            <div
              style={{
                fontStyle: "normal",
                fontWeight: "800",
                fontSize: "20px",
                lineHeight: "25px",
                color: "#282828",
              }}
            >
              Transaction Completed
            </div>
            <div
              style={{
                paddingTop: "20px",
                fontFamily: "Inter",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "16px",
                lineHeight: "140%",
                /* or 22px */

                textAlign: "center",

                color: "#696969",
              }}
            >
              You’ve successfully migrated your
              <br />{" "}
              <span style={{ fontWeight: "800", color: "#282828" }}>
                {" "}
                {value
                &&(
                  (new BigNumber(parseFloat(value)).lt(1))?new BigNumber(parseFloat(value)).valueOf():millify(new BigNumber(parseFloat(value)).valueOf(), {
                    precision: 3,
                    lowercase: false,
                  }))}{" "}
                MContent{" "}
              </span>{" "}
              from{" "}
              {(claimItem)?<span style={{ fontWeight: "600", color: "#282828" }}>
                {chainId === supportedChains[0] ? "BEP20" : "ERC20"}
              </span>:<span style={{ fontWeight: "600", color: "#282828" }}>
                {chainId === supportedChains[0] ? "ERC20" : "BEP20"}
              </span>}{" "}
              to{" "}
              {(claimItem)?(<span style={{ fontWeight: "600", color: "#282828" }}>
                {chainId === supportedChains[0] ? "ERC20" : "BEP20"}
              </span>):(<span style={{ fontWeight: "600", color: "#282828" }}>
                {chainId === supportedChains[0] ? "BEP20" : "ERC20"}
              </span>)}
              {(type=="deposite")&& <p style={{fontWeight:"700", paddingTop:"10px", color: "#282828"}}>{"Your transaction will be in the claim tab shortly"}</p>}
            </div>
            <div style={{display:"flex", placeContent:"center"}}>
              <a href={((chainId== supportedChains[0])?etherScanExplorerURL:bscScanExplorerURL)+transactionHash} className={classes.Link} rel="external nofollow noopener"
                    target="_blank"><span style={{display:"flex",alignItems:"center", marginRight:"5px"}}>
                    <img src={ViewIcon} />
                            </span><span>View on Exporer</span> </a>
              </div>
          </div>
        </div>
      </TransactionModal>
    </div>
  );
}

export default TransactionSuccessfull;
